<section class="container" [formGroup]="form">
  <div class="card shadow">
    <div class="card-header d-flex align-items-center">
      <a routerLink="/rota-volta" class="text-dark mr-2">
        <i class="fa fa-arrow-left"></i>
      </a>
      <h3 class="card-title font-weight-semibold mb-0">Compra de Benefícios</h3>
    </div>

    <div class="card-body">
      <ul class="nav nav-fill nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [class.active]="aba === 'executar'" (click)="aba = 'executar'">
            <i class="fa fa-credit-card"></i><span class="ml-1">Efetivar nova compra</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="aba === 'historico'"
            (click)="abrirHistoricoBeneficios()"
          >
            <i class="fa fa-history"></i><span class="ml-1">Compras realizadas</span>
          </a>
        </li>
      </ul>

      <div class="tab-content p-2">
        <!-- ABA EXECUTAR -->
        <div
          class="tab-pane fade"
          [class.show]="aba === 'executar'"
          [class.active]="aba === 'executar'"
        >
          <div class="row">
            <div class="col-md-4 form-group">
              <label class="font-weight-semibold">Competência</label>
              <input
                type="text"
                class="form-control shadow-sm"
                formControlName="competencia"
                placeholder="MM/AAAA"
                inputmode="numeric"
                maxlength="7"
                (input)="mascararCompetencia($event)"
                (blur)="normalizarCompetencia()"
              />
            </div>

            <div class="col-md-6 form-group">
              <label class="font-weight-semibold">Benefício</label>
              <select class="form-control shadow-sm" formControlName="beneficio">
                <option value="">Selecione...</option>
                <option *ngFor="let b of beneficios" [value]="b.value">{{ b.label }}</option>
              </select>
            </div>

            <div class="col-md-2 form-group">
              <label>&nbsp;</label>
              <button
                type="button"
                class="btn btn-primary btn-block"
                (click)="buscarBeneficio()"
                [disabled]="form.invalid || carregandoLista"
              >
                <i *ngIf="!carregandoLista" class="fa fa-search"></i>
                <i *ngIf="carregandoLista" class="fa fa-spinner fa-spin"></i>
                <span *ngIf="carregandoLista" class="ml-1">Carregando...</span>
              </button>
            </div>
          </div>

          <div *ngIf="carregandoLista" class="text-center p-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
            <p class="mt-2 text-muted">Carregando colaboradores...</p>
          </div>

          <div
            *ngIf="!carregandoLista && (ativos.length || afastados.length)"
            class="col-md-12 form-group table-responsive border-top pt-3"
          >
            <div class="d-flex justify-content-between align-items-center">
              <h2 class="h5 text-muted mb-0">Colaboradores Ativos</h2>
              <div>
                <label class="mr-2 mb-0">
                  <input
                    type="checkbox"
                    [checked]="todosAtivosSelecionados"
                    (change)="toggleSelecionarTodos('A')"
                  />
                  Selecionar todos
                </label>
              </div>
            </div>

            <table class="table table-striped mt-2">
              <thead>
                <tr>
                  <th></th>
                  <th>Matrícula</th>
                  <th>Nome</th>
                  <th class="text-right">QTD Dia</th>
                  <th class="text-right">Valor Dia (R$)</th>
                  <th class="text-right">Dias Necessários</th>
                  <th class="text-right" style="max-width: 140px">QTD Necessária</th>
                  <th class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let f of ativos; trackBy: trackByMat">
                  <td>
                    <input
                      type="checkbox"
                      [(ngModel)]="f._selecionado"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="recalcularTotais()"
                    />
                  </td>

                  <td>{{ f.Mat }}</td>

                  <td>
                    <strong class="d-block">{{ f.Nome }}</strong>
                    <small class="text-info">{{ f.DescLotacao }} ({{ f.Modalidade }})</small>
                  </td>
                  <td class="text-right">{{ f.QtdDia }}</td>

                  <td class="text-right">{{ f.ValorDia | number : '1.2-2' }}</td>

                  <td class="text-right" style="max-width: 140px">
                    <input
                      type="number"
                      class="form-control text-right"
                      [(ngModel)]="f.DiasNecessarios"
                      [ngModelOptions]="{ standalone: true }"
                      min="0"
                      (ngModelChange)="recalcularLinha(f)"
                    />
                  </td>

                  <td class="text-right">{{ f.QtdSugerida }}</td>

                  <td class="text-right">{{ f._total | number : '1.2-2' }}</td>
                </tr>

                <tr *ngIf="!ativos.length">
                  <td colspan="7" class="text-center text-muted">Nenhum ativo para exibir.</td>
                </tr>
              </tbody>
            </table>

            <!-- TABELA AFASTADOS -->
            <div class="d-flex justify-content-between align-items-center mt-4">
              <h2 class="h5 text-muted mb-0">Colaboradores Afastados</h2>
              <div>
                <label class="mr-2 mb-0">
                  <input
                    type="checkbox"
                    [checked]="todosAfastadosSelecionados"
                    (change)="toggleSelecionarTodos('F')"
                  />
                  Selecionar todos
                </label>
              </div>
            </div>

            <table class="table table-striped mt-2">
              <thead>
                <tr>
                  <th></th>
                  <th>Matrícula</th>
                  <th>Nome</th>
                  <th class="text-right">QTD dia</th>
                  <th class="text-right">Valor Dia (R$)</th>
                  <th class="text-right">Dias Necessários</th>
                  <th class="text-right" style="max-width: 140px">QTD Necessária</th>
                  <th class="text-right">Total</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let f of afastados; trackBy: trackByMat">
                  <td>
                    <input
                      type="checkbox"
                      [(ngModel)]="f._selecionado"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="recalcularTotais()"
                    />
                  </td>

                  <td>{{ f.Mat }}</td>

                  <td>
                    <strong class="d-block">{{ f.Nome }}</strong>
                    <small class="text-info">{{ f.DescLotacao?.trim() }}</small>
                  </td>

                  <td class="text-right">{{ f.QtdDia }}</td>

                  <td class="text-right">{{ f.ValorDia | number : '1.2-2' }}</td>

                  <td class="text-right" style="max-width: 140px">
                    <input
                      type="number"
                      class="form-control text-right"
                      [(ngModel)]="f.DiasNecessarios"
                      [ngModelOptions]="{ standalone: true }"
                      min="0"
                      (ngModelChange)="recalcularLinha(f)"
                    />
                  </td>

                  <td class="text-right">{{ f.QtdSugerida }}</td>

                  <td class="text-right">{{ f._total | number : '1.2-2' }}</td>
                </tr>

                <tr *ngIf="!afastados.length">
                  <td colspan="8" class="text-center text-muted">Nenhum afastado para exibir.</td>
                </tr>
              </tbody>
            </table>

            <hr />
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <button
                  class="btn btn-outline-secondary mr-2"
                  (click)="limparSelecoes()"
                  [disabled]="!temSelecao()"
                >
                  Limpar seleção
                </button>
              </div>
              <h3 class="text-danger mb-0">
                <small class="mr-2">R$</small><span>{{ totalGeral | number : '1.2-2' }}</span>
              </h3>
            </div>

            <div class="text-right mt-3">
              <button
                class="btn btn-primary"
                (click)="efetivarCompra()"
                [disabled]="!podeEfetivar()"
              >
                Efetivar compra
              </button>
            </div>
          </div>
        </div>

        <!-- ABA HISTÓRICO -->

        <div
          class="tab-pane fade"
          [class.show]="aba === 'historico'"
          [class.active]="aba === 'historico'"
        >
          <div class="row">
            <div class="col-12 table-responsive">
              <div *ngIf="carregandoHistorico" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
                <p class="mt-2 text-muted">Carregando histórico...</p>
              </div>

              <table *ngIf="!carregandoHistorico" class="table table-striped">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Competência</th>
                    <th>Benefício</th>
                    <th>QTD</th>
                    <th>Valor (R$)</th>
                    <th>Responsável</th>
                    <th class="text-right">Detalhar <i class="fa fa-eye"></i></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let h of historico">
                    <td>{{ h.CodigoCompraBeneficio }}</td>
                    <td>{{ h.AnoMes }}</td>
                    <td class="text-info">{{ h.NomeBeneficio }}</td>
                    <td>{{ h.TotalQuantidade }}</td>
                    <td>
                      <strong class="text-success">{{ h.TotalValor | number : '1.2-2' }}</strong>
                    </td>
                    <td>
                      <span class="d-block">{{ h.CodUsuario }}</span>
                      <small class="text-muted">{{ formatarData(h.DataHora) }}</small>
                    </td>
                    <td class="text-right">
                      <button
                        type="button"
                        class="btn btn-outline-info btn-sm"
                        (click)="abrirDetalhe(h)"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="!carregandoHistorico && !historico.length">
                    <td colspan="7" class="text-center text-muted">
                      Sem registros para a competência/benefício.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer"></div>
  </div>
</section>

<div
  class="modal fade"
  id="modal-detalhe"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalDetalheTitle"
  aria-hidden="true"
  #modalDetalhe
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 id="modalDetalheTitle" class="modal-title text-info d-flex align-items-center">
          <i class="fa fa-shopping-cart mr-2"></i>
          <span>Detalhamento</span>
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="fecharModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="carregandoDetalhe" class="text-center p-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2 text-muted">Carregando detalhes...</p>
        </div>

        <div *ngIf="!carregandoDetalhe && detalhe" class="table-responsive">
          <table class="table table-striped mb-3">
            <thead>
              <tr>
                <th>Matrícula</th>
                <th>Nome</th>
                <th class="text-right">QTD Dia</th>
                <th class="text-right">Valor Dia (R$)</th>
                <th class="text-right">Dias Necessários</th>
                <th class="text-right">Quantidade</th>
                <th class="text-right">Valor Total (R$)</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let i of detalhe.itens; trackBy: trackByMat"
                [class.table-warning]="i._editado"
              >
                <td>{{ i.Mat }}</td>

                <td>
                  <strong class="d-block">{{ i.Nome }}</strong>
                  <small class="text-info">{{ i.DescLotacao }}</small>
                </td>

                <td class="text-right">{{ i.QtdDia || 0 }}</td>

                <td class="text-right">{{ i.ValorDia | number : '1.2-2' }}</td>

                <td class="text-right" style="min-width: 120px">
                  <input
                    type="number"
                    class="form-control text-right"
                    [(ngModel)]="i.DiasNecessarios"
                    [ngModelOptions]="{ standalone: true }"
                    min="0"
                    max="31"
                    (ngModelChange)="recalcularLinhaDetalhe(i)"
                  />

                  <small
                    *ngIf="i.DiasNecessarios !== i.DiasNecessariosOriginal"
                    class="text-warning"
                  >
                    Original: {{ i.DiasNecessariosOriginal }}
                  </small>
                </td>

                <td class="text-right">
                  {{ i.Quantidade }}
                </td>

                <td class="text-right">
                  <span [class.text-success]="i._editado">
                    {{ i.Valor | number : '1.2-2' }}
                  </span>
                  <div *ngIf="i._editado" class="badge badge-warning ml-1">Editado</div>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-outline-danger btn-sm"
                    (click)="excluirItemDetalhe(i)"
                    [disabled]="detalhe.itens.length <= 1"
                    title="Excluir item"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex justify-content-between align-items-center border-top pt-3">
            <h3 class="text-danger mb-0">
              <small class="mr-2">Total: R$</small>
              <span>{{ detalhe.total | number : '1.2-2' }}</span>
            </h3>
          </div>
        </div>

        <!-- MENSAGEM QUANDO NÃO TEM DETALHE E NÃO ESTÁ CARREGANDO -->
        <div *ngIf="!carregandoDetalhe && !detalhe" class="text-center p-4">
          <p class="text-muted">Nenhum detalhe disponível.</p>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="fecharModal()">
          Fechar
        </button>

        <button
          type="button"
          class="btn btn-info"
          (click)="baixarArquivoDetalhamento()"
          [disabled]="!detalhe || carregandoDetalhe"
        >
          <i class="fa fa-download mr-1"></i>
          Baixar Arquivo
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="atualizarCompra()"
          [disabled]="!detalheModificado || carregandoDetalhe"
        >
          <i class="fa fa-save mr-1"></i>
          Atualizar Compra
        </button>
      </div>
    </div>
  </div>
</div>
